module.exports = __webpack_public_path__ + "static/media/upload-small-icn.ddd07e07.svg";